class WebSocketService {
    private static instance: WebSocketService;
    private socket: WebSocket | null = null;
    public onGameStateUpdate: ((gameState: any) => void) | null = null;
    public onDisconnect: (() => void) | null = null;

    private constructor() {}

    public static getInstance(): WebSocketService {
        if (!WebSocketService.instance) {
            WebSocketService.instance = new WebSocketService();
        }
        return WebSocketService.instance;
    }

    public connect(roomCode: string, playerName: string, roomName?: string, playerId?: string) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) return;

        const params = new URLSearchParams();
        params.set('name', playerName);
        if (roomName) params.set('roomName', roomName);
        if (playerId) params.set('playerId', playerId);

        const wsUrl = `${(process.env.REACT_APP_WS_URL || '')}/${roomCode}?${params.toString()}`;
        console.log(`Connecting to ${wsUrl}`);

        this.socket = new WebSocket(wsUrl);

        this.socket.onopen = () => {
            console.log("WebSocket connected");
        };

        this.socket.onmessage = (event) => {
            const message = JSON.parse(event.data);
            if (message.type === 'gameState' && this.onGameStateUpdate) {
                this.onGameStateUpdate(message.payload);
            }
        };

        this.socket.onclose = (event) => {
            console.log("WebSocket disconnected");
            if (event.code === 1008) {
                alert(`連線被拒絕: ${event.reason}`);
            } else if (this.onDisconnect) {
                this.onDisconnect();
            }
            this.socket = null;
        };

        this.socket.onerror = (error) => {
            console.error("WebSocket error: ", error);
            if (this.onDisconnect) {
                this.onDisconnect();
            }
            this.socket = null;
        };
    }

    public sendMessage(message: any) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            this.socket.send(JSON.stringify(message));
        } else {
            console.error("WebSocket is not connected.");
        }
    }

    public disconnect() {
        if (this.socket) {
            this.socket.close();
        }
    }
}

export const webSocketService = WebSocketService.getInstance();